import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Footer from '../../components/Footer';
// import Sidebar from '../../components/Sidebar';
import AlertMessage from '../../AlertMessage';
import loading from '../../assets/images/loading.jpg.gif';
function Sadhyachasatha() {
  const [data, setData] = useState([]);
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const language = localStorage.getItem("language");
  const [isLoading, setIsLoading] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [schoolData, setSchoolData] = useState(null);
  const [isInitialFetchDone, setIsInitialFetchDone] = useState(false); // New state variable
  const [countTotal, setCountTotal] = useState('');
  const [countCookedDays, setCountCookedDays] = useState(0);
  const [countlabharthi, setCountlabharthi] = useState(0);
  const [numberOfCooks, setNumberOfCooks] = useState('');

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);
  const classMapping = {
    '1 To 5': {
      English: "1 To 5",
      Marathi: "१ ली ते ५ वी"
    },
    '6 To 8': {
      English: "6 To 8",
      Marathi: "६ वी ते ८ वी"
    }
  };

  
  useEffect(() => {
    // Automatically fetch data only on the first render
    if (!isInitialFetchDone && selectedYear && selectedMonth && selectedClass) {
      fetchData();
      setIsInitialFetchDone(true); // Set the flag to true after the first fetch
    }
  }, [selectedYear, selectedMonth, selectedClass, isInitialFetchDone]);

  const predefinedVastuNames = language === 'English' 
    ? ['Rice', 'Mugdal', 'Turdal', 'Masurdal', 'Matki', 'Moong', 'Cowpea', 'Gram', 'Pease', 'Cumin', 'Mustard', 'Turmeric', 'Chili', 'Oil', 'Salt', 'Onion Garlic Masala', 'Garam Masala', 'Vegetables', 'Milk-Milk Powder','Sugar-Jaggery', 'Soyabean Wadi', 'Ragi Satva'] 
    : ['तांदूळ', 'मुगडाळ', 'तूरडाळ', 'मसूरडाळ', 'मटकी', 'मूग', 'चवळी', 'हरभरा', 'वाटाणा', 'जिरे', 'मोहरी', 'हळद', 'मिरची', 'तेल', 'मीठ','कांदा लसूण मसाला', 'गरम मसाला', 'भाजी पाला',  'दूध-दूध पावडर','साखर-गूळ','सोयाबीन वडी','नाचणी सत्व'];
  
  const [monthData, setMonthData] = useState({});
  const monthNames = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };
  const fetchOpeningMonthYear = async () => {
    const openingMonthYearUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/openingMonthyear.json`;
    try {
      const response = await axios.get(openingMonthYearUrl);
      const data = response.data || null;
  
      if (data) {
        // Check for the presence of both classes
        const hasClass1To5 = data['1 To 5'] !== undefined;
        const hasClass6To8 = data['6 To 8'] !== undefined;
  
        // Set selected class based on available classes
        let selectedClass; // Declare a variable to hold the selected class
        if (hasClass1To5 && hasClass6To8) {
          selectedClass = '1 To 5'; // Default to '1 To 5' if both are present
        } else if (hasClass1To5) {
          selectedClass = '1 To 5';
        } else if (hasClass6To8) {
          selectedClass = '6 To 8';
        } else {
          setAlertMessage('No data yet to be filled.');
          return; 
        }
        const selectedClassData = data[selectedClass]; 
        
        setSelectedYear(selectedClassData.year);
        setSelectedMonth(monthNames[selectedClassData.month]);
        setSelectedClass(selectedClass); // Now set the state for selectedClass
      } else {
        setAlertMessage('No data yet to be filled.');
      }
    } catch (error) {
      console.error('Error fetching opening month and year:', error);
      setAlertMessage('Error fetching opening month and year.');
    }
  };

  useEffect(() => {
    fetchOpeningMonthYear();
    fetchSchoolData(); 
   
    
  }, [udiseNumber]);

  
      const DB_NAME = 'SchoolManagementDB';
    const SCHOOL_STORE = 'schoolData';
    const DB_VERSION = 1;



const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = (event) => {
      console.error("IndexedDB error:", event.target.error);
      reject(event.target.error);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      if (!db) {
        console.error("Error: db object is not initialized");
        reject("Error: db object is not initialized");
      } else {
        resolve(db);
      }
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

    
      if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
        db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
      }
    };
  });
};

  
     const fetchSchoolData = async () => {
  try {
    const db = await openDB();
    const transaction = db.transaction(SCHOOL_STORE, "readonly");
    const store = transaction.objectStore(SCHOOL_STORE);
    const udise = localStorage.getItem("udiseNumber");
    const request = store.get(udise);

    return new Promise((resolve) => {
      request.onsuccess = (event) => {
        const data = event.target.result;
        if (data) {
          console.log("School data from IndexedDB:", data);
          setSchoolData(data);
          resolve(data);
        } else {
          console.log("No school data found in IndexedDB, fetching from Firebase");
        }
      };

      request.onerror = (event) => {
        console.error("Error fetching school data from IndexedDB:", event.target.error);
      };
    });
  } catch (error) {
    console.error("Error accessing IndexedDB:", error);
  }
};

  const saveShillakVastu = async (monthData) => {
    try {
      // Fetch existing data
      const existingDataUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/sadhyachasatha/${selectedClass}/${selectedYear}/${selectedMonth}.json`;
      const existingDataResponse = await axios.get(existingDataUrl);
      const existingData = existingDataResponse.data || {};

      // Prepare new data to merge
      const newShillakData = {};
      monthData.forEach(item => {
        if (item.shillakVastu !== 0) {
          newShillakData[item.vastuName] = item.shillakVastu;
        }
      });

      // Merge existing data with new data
      const mergedData = { ...existingData, ...newShillakData };

      // Save merged data
      await axios.put(existingDataUrl, mergedData);
    } catch (error) {
      console.error('Failed to save shillakVastu values:', error);
      setAlertMessage('Failed to save shillakVastu values.');
    }
  };
  const fetchPreviousMonthShillak = async (year, month) => {
    // Fetch the opening month and year for the selected class
    const openingMonthYearUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/openingMonthyear.json`;
    let openingData;
  
    try {
      const response = await axios.get(openingMonthYearUrl);
      openingData = response.data[selectedClass]; // Get the data for the selected class
    } catch (error) {
      console.error('Error fetching opening month and year:', error);
      return {}; // Return empty if there's an error
    }
  
    if (!openingData) {
      return {};
    }
  
    const openingYear = openingData.year;
    const openingMonthIndex = openingData.month - 1; // Convert to 0-based index
  
    let currentYear = year;
    let currentMonthIndex = new Date(Date.parse(month + " 1, " + year)).getMonth();
  
    // Determine the maximum year and month to loop back to
    let maxYear = currentYear;
    let maxMonthIndex = currentMonthIndex - 1; // Start from the previous month
  
    if (!isInitialFetchDone) {
      // On first visit, render only till the current month and year
      maxYear = currentYear;
      maxMonthIndex = currentMonthIndex - 1; 
    } else {
      if (openingYear < currentYear - 3) {
        // If the opening year is more than 3 years ago, limit to opening year/month
        maxYear = openingYear;
        maxMonthIndex = openingMonthIndex; // Limit to opening month
      } else {
        // If within 3 years, allow fetching data for the last 3 years
        maxYear = Math.max(openingYear, currentYear - 3);
        maxMonthIndex = (openingYear === currentYear) ? openingMonthIndex : 11; // If the opening year is the current year, limit to opening month
       
        
      }
    }
  
    // Check from the current month backwards
    for (let y = currentYear; y >= maxYear; y--) {
      // Determine the starting month for the current year
      const startMonthIndex = (y === currentYear) ? currentMonthIndex - 1 : 11; // Start from the current month or December for previous years
  
      for (let m = startMonthIndex; m >= 0; m--) {
        // Check if we should stop at the opening month/year
        if (y === openingYear && m < openingMonthIndex) {
          break; // Stop if we reach the opening month
        }
  
        const previousMonthDate = new Date(y, m);
        const previousMonthName = previousMonthDate.toLocaleString('default', { month: 'long' });
        const previousMonthYear = previousMonthDate.getFullYear();
  
        const previousMonthShillakUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/sadhyachasatha/${selectedClass}/${previousMonthYear}/${previousMonthName}.json`;
        
  
        try {
          const response = await axios.get(previousMonthShillakUrl);
          const previousMonthData = response.data || {};
  
          if (Object.keys(previousMonthData).length > 0) {
            return previousMonthData; // Return the first found data
          }
        } catch (error) {
          console.error(`Failed to fetch data for ${previousMonthName} ${previousMonthYear}:`, error);
        }
      }
    }
  
    return {}; // Return an empty object if no data is found
  };
  const monthMapping = {
    January: "जानेवारी",
    February: "फेब्रुवारी",
    March: "मार्च",
    April: "एप्रिल",
    May: "मे",
    June: "जून",
    July: "जुलै",
    August: "ऑगस्ट",
    September: "सप्टेंबर",
    October: "ऑक्टोबर",
    November: "नोव्हेंबर",
    December: "डिसेंबर",
  };
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const praptVastuUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/avaksatha/${selectedClass}/${selectedYear}/${selectedMonth}/vastuDetails.json`;

      const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const monthNumber = new Date(`${selectedMonth} 1, ${selectedYear}`).getMonth() + 1;
      const formattedMonth = String(monthNumber).padStart(2, '0');

      let useVastuData = {};
      let totalUseVastu = {};

      for (let day of daysOfWeek) {
        const useVastuUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/dainandinnondani/${selectedClass}/${selectedYear}/${formattedMonth}/${day}.json`;

        const response = await axios.get(useVastuUrl);
        const dayData = response.data || {};

        if (Object.keys(dayData).length > 0) {
          useVastuData = { ...useVastuData, ...dayData };

          Object.keys(dayData).forEach((date) => {
            const dayVastuData = dayData[date];
            Object.keys(dayVastuData).forEach((vastuName) => {
              if (!totalUseVastu[vastuName]) {
                totalUseVastu[vastuName] = 0;
              }
              totalUseVastu[vastuName] += parseInt(dayVastuData[vastuName], 10);
            });
          });
        }
      }

      const previousMonthShillak = await fetchPreviousMonthShillak(selectedYear, selectedMonth);


      const praptVastuResponse = await axios.get(praptVastuUrl);
      const praptVastuData = praptVastuResponse.data || {};
      fetchCookedDays();
      
    handleFetchStudentCount();
      const cookedDaysForItems = await fetchCookedDaysForItems();
   
      
      const newData = predefinedVastuNames.map((vastuName) => {
        const praptValue = parseInt(praptVastuData[vastuName] || '0', 10);
        const useValue = totalUseVastu[vastuName] || 0;
        const magilSillak = previousMonthShillak[vastuName] || 0;

        const totalVastu = praptValue + magilSillak;
        const shillakVastu = totalVastu - useValue;
        const cookedDays = cookedDaysForItems[vastuName] || 0; 
        

        return {
          vastuName,
          magilSillak,
          praptVastu: praptValue,
          totalVastu,
          useVastu: useValue,
          shillakVastu,
          cookedDays 
        };
      });

      // Update the month data state
      setMonthData((prevMonthData) => ({ ...prevMonthData, [selectedMonth]: newData }));

      // Set the calculated data
      setData(newData);

      setIsTableVisible(true);
      await saveShillakVastu(newData);
    } catch (error) {
      console.error('Failed to fetch data:', error);
      setAlertMessage('Failed to fetch data.');          
    }
    finally{
      setIsLoading(false); // Stop loading
    }
  };

  const handleArrowClick = () => {
    if (!selectedYear || !selectedMonth || !selectedClass) {
      setAlertMessage('Please select year, month, and class first.');
      return;
    }

    fetchData();
    setIsTableVisible(prevState => !prevState);
  };
  
  
  const handleReport = async () => {
    if (!data.length) {
      setAlertMessage('No data available to report.');
      return;
    }


    const modalDataToShow = data.map((item, index) => ({
      content: item.vastuName,
      previousStock: item.magilSillak,
      receivedGoods: item.praptVastu,
      totalGoods: item.totalVastu,
      itemsUsed: item.useVastu,
      remainingStock: item.shillakVastu,
      cookedDays : item.cookedDays ,
      countlabharthi:countlabharthi
    }));
    setModalData(modalDataToShow);
    setShowModal(true);
  };

  const handleFetchStudentCount = async () => {
    try {
      // Construct the fetch URL
      const fetchUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
  
      // Fetch student data from Firebase
      const response = await axios.get(fetchUrl);
      const studentData = response.data || {};
  
  
      if (!studentData) {
        return; // or throw an error if needed
      }
  
      // Declare class ranges
      let classRange1 = [];
      let classRange2 = [];
  
      // Set class ranges based on the language
      if (language === 'English') {
        classRange1 = ['Class I', 'Class II', 'Class III', 'Class IV', 'Class V'];
        classRange2 = ['Class VI', 'Class VII', 'Class VIII'];
      } else {
        classRange1 = ['इयत्ता पहिली', 'इयत्ता दुसरी', 'इयत्ता तिसरी', 'इयत्ता चौथी', 'इयत्ता पाचवी'];
        classRange2 = ['इयत्ता सहावी', 'इयत्ता सातवी', 'इयत्ता आठवी'];
      }
  
      let countClass1to5 = 0;
      let countClass6to8 = 0;
  
      // Iterate over student data
      Object.values(studentData).forEach((student) => {
        if (student !== null) { 
  
          const trimmedCurrentClass = student.currentClass.trim(); // Trim extra spaces
  
          if (classRange1.includes(trimmedCurrentClass)) {
            countClass1to5++;
          } else if (classRange2.includes(trimmedCurrentClass)) {
            countClass6to8++;
          }
        }
      });
  
      
      if (selectedClass === '1 To 5') {
        setCountTotal(countClass1to5)
      }
      else{
        setCountTotal(countClass6to8)
      }
  
      // Return the counts if needed
      return { countClass1to5, countClass6to8 };
    } catch (error) {
      console.error('Failed to fetch student data:', error);
    }
  };

  const fetchCookedDays = async () => {

    const monthNumber = new Date(`${selectedMonth} 1, ${selectedYear}`).getMonth() + 1;
    const formattedMonth = String(monthNumber).padStart(2, '0');
  
    const fetchUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/dainandinnondani/${selectedClass}/${selectedYear}/${formattedMonth}.json`;
   
    
    try {
      const response1 = await axios.get(fetchUrl);
      const data1 = response1.data; 

      // Count cooked days and labharthi for 1 To 5
      let count = 0;
      let labharthiCount = 0;

      Object.keys(data1).forEach(day => {
        count += Object.keys(data1[day]).length; // Count entries for each weekday
        Object.values(data1[day]).forEach(entry => {
          if (entry.labharthi) {
            labharthiCount += parseInt(entry.labharthi, 10); // Sum labharthi values
          }
        });
      });

      setCountCookedDays(count || 0);
      setCountlabharthi(labharthiCount || 0);
     
    } catch (error) {
      console.error('Error fetching cooked days:', error);
    }
  };
  const fetchCookedDaysForItems = async () => {
    const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const monthNumber = new Date(`${selectedMonth} 1, ${selectedYear}`).getMonth() + 1;
    const formattedMonth = String(monthNumber).padStart(2, '0');

    let cookedDaysData = {};
  
    for (let day of daysOfWeek) {
      const useVastuUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/dainandinnondani/${selectedClass}/${selectedYear}/${formattedMonth}/${day}.json`;
  
  
      try {
        const response = await axios.get(useVastuUrl);
        const dayData = response.data || {};
  
        Object.keys(dayData).forEach(date => {
          const dayVastuData = dayData[date];
          
          Object.keys(dayVastuData).forEach(vastuName => {
            if (!cookedDaysData[vastuName]) {
              cookedDaysData[vastuName] = 0; 
            }
            cookedDaysData[vastuName] += 1; 
          });
        });
      } catch (error) {
        console.error(`Failed to fetch data for ${day}:`, error);
      }
    }
  
    return cookedDaysData; 
  };


  const closeModal = () => {
    setShowModal(false); 
  };
  
const handlePrint = () => {
  const printContent = document.querySelector('.modal-content');

  if (printContent) {
    const cloneContent = printContent.cloneNode(true);

    const schoolName = cloneContent.querySelector('p');
    const otherDetails = cloneContent.querySelectorAll('p');

    otherDetails.forEach((p, index) => {
      if (index !== 0) {
        p.style.fontWeight = 'normal';
      }
    });

    const printWindow = window.open('', '');
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Modal Content</title>
          <style>
            @page {
              size: A4 landscape; /* Set A4 size in landscape orientation */
              margin: 3mm; /* Set appropriate margins for printing */
            }
              
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 10mm 1mm;
              font-size: 10px; /* Set font size for body */
            }
            .modal-content {
              margin: 0;
              width: 100%;
            }
            table {
              width: 100%; /* Set table to use full width */
              border-collapse: collapse;
            }
            th, td {
              border: 1px solid black;
              padding: 3px;
              text-align: center;
              font-size: 10px;
            }
            thead {
              background-color: #F0F0F0;
            }
            .container-masikpatra {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              padding: 0px;
              margin-bottom: 0px;
              margin-top:-15px
            }
            .leftpartmasikpatr, .cenetrpartmasikpatr, .rightpartmasikpatr {
              margin: 0 10px;
              border: none;
            }
            .leftpartmasikpatr {
              text-align: left;
            }
            .cenetrpartmasikpatr {
              margin-bottom: -5px;
            }
            .cenetrpartmasikpatr-p {
              color: black;
              margin-top: -5px;
              font-size: 11px;
            }
            .rightpartmasikpatr {
              width: 220px;
              padding: 10px;
            }
            .rowmasikpatr {
              display: flex;
              margin: -8px !important;
              padding: 0;
            }
            .columnmasikpatr {
              margin-top: 10px;
              margin-bottom: -8px;
              flex: 1;
              text-align: left;
            }
          </style>
        </head>
        <body>
          ${cloneContent.outerHTML} <!-- Include the modified outer HTML of the modal content -->
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print(); // Trigger print
    printWindow.close(); // Close the print window after printing
  } else {
    console.error('Print content not found');
  }
};

  return (
    <div>
      {/* <Sidebar /> */}
      <AlertMessage message={alertMessage} show={showAlert} />
     <div className="main-content-of-page">

     <div>
        <h3 className='text-center mb-5' style={{ color: '#03365e', fontWeight: '600' }}>
          {language === "English" ? "Current Stock" : "सध्याचा साठा"}
        </h3>
        <form style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '20px' }}>
          <div className="form-group" style={{ flex: '1', minWidth: '10px' }}>
            <label htmlFor="year" style={{ display: 'block', marginBottom: '5px', fontSize: '1.1em' }}>
              {language === "English" ? "Year" : "वर्ष"}:
            </label>
            <select style={{ width: '100%', padding: '10px', fontSize: '1em' }} id="year" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
              <option value="">{language === "English" ? "Select Year" : "वर्ष निवडा"}</option>
              {[...Array(8)].map((_, index) => {
                const year = 2023 + index;
                return <option key={year} value={year}>{year}</option>;
              })}
            </select>
          </div>
          <div className="form-group" style={{ flex: '1', minWidth: '120px' }}>
            <label htmlFor="month" style={{ display: 'block', marginBottom: '5px', fontSize: '1.1em' }}>
              {language === "English" ? "Month" : "महिना"}:
            </label>
            <select style={{ width: '100%', padding: '10px', fontSize: '1em' }} id="month" value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} >
              <option value="">{language === "English" ? "Select Month" : "महिना निवडा"}</option>
              {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month) => (
                <option key={month} value={month}>{language === "English" ? month : month}</option>
              ))}
            </select>
          </div>
          <div className="form-group" style={{ flex: '1', minWidth: '120px' }}>
            <label htmlFor="class" style={{ display: 'block', marginBottom: '5px', fontSize: '1.1em' }}>
              {language === "English" ? "Class" : "वर्ग"}:
            </label>
            <select style={{ width: '100%', padding: '10px', fontSize: '1em' }} id="class" value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)}  >
              <option value="">{language === "English" ? "Select Class" : "वर्ग निवडा"}</option>
              <option value="1 To 5">{language === "English" ? "1 To 5" : "१ ते ५"}</option>
              <option value="6 To 8">{language === "English" ? "6 To 8" : "६ ते ८"}</option>
            </select>
          </div>
        </form>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap:'70px' ,margin
        : '30px auto' }}>
    <button 
        onClick={handleArrowClick} 
        style={{ 
            padding: '10px 20px', 
            backgroundColor: '#4CAF50', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer', 
            marginRight: '10px' // Space between buttons
        }}
    >
        {language === "English" ? "View Data" : "डेटा पहा"}
    </button>

    <button 
        onClick={handleReport} 
        style={{ 
            padding: '10px 20px', 
            backgroundColor: '#d4a017', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer' 
        }}
    >
        Report
    </button>
</div>
        {isLoading && (
          <div style={loadingoverlay}>
            <img src={loading} alt="Loading..."   width={'70px'}  height= {'70px'} />
          </div>
        )}
        {isTableVisible && (
          <div>
          <table style={{ width: '98%',margin:'20px 1% ', borderCollapse: 'collapse', marginBottom:'45px'}}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign:'center' }}>{language === "English" ? "Goods" : "वस्तू"}</th>
                <th style={{ border: '1px solid black',                padding: '8px', textAlign:'center' }}>{language === "English" ? "Previous Stock" : "मागील शिल्लक"}</th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign:'center' }}>{language === "English" ? "Received Goods" : "प्राप्त वस्तू"}</th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign:'center' }}>{language === "English" ? "Total Goods" : "एकूण वस्तू"}</th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign:'center' }}>{language === "English" ? "Food Cooked Days" : "अन्न शिजवलेले दिवस"}</th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign:'center' }}>{language === "English" ? "Beneficiery - in current month" : "लाभार्थी - चालू महिन्यातील "}</th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign:'center' }}>{language === "English" ? "Items used for cooking food" : "अन्न शिजवण्यासाठी वापरलेल्या वस्तू"}</th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign:'center' }}>{language === "English" ? "Remaining Goods" : "शिल्लक वस्तू"}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{item.vastuName}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{item.magilSillak}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{item.praptVastu}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{item.totalVastu}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{item.cookedDays}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{item.cookedDays * countlabharthi }</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{item.useVastu}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{item.shillakVastu}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
</div>


{showModal && (
  <div style={{
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '1000',
  }}>
    <div style={{
      backgroundColor: '#fff',
      padding: '30px',
      borderRadius: '10px',
      width: '80%',
      maxWidth: 'fit-content',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
      maxHeight: '90%',
      overflowY: 'auto',
      position: 'relative',
    }}>
      <div className="modal-content">
        {/* Transpose the modalData */}
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '30px',
          fontFamily: 'Arial, sans-serif',
          border: '1px solid black',
          borderRadius: '10px',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        }}>
          <thead>
          {schoolData && (
                      <tr>
                        <th colSpan="20" style={{

                          color: 'black',
                          padding: '5px',
                          borderRadius: '10px 10px 0 0',
                          textAlign: 'center',
                          lineHeight: '0.4',
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          fontSize: '12px'
                        }}>
                        <p style={{ fontSize: '13px', marginTop:'10px', marginLeft:'50px'}}>{language === "English" ? "Pradhan Mantri Poshan Shakti Nirman Yojana" : "प्रधानमंत्री पोषण शक्ती निर्माण योजना"}</p>

                        <div className='container-masikpatra'>
  <div className='leftpartmasikpatr'>
    <p>{language === "English" ? "Center" : "केंद्र"} : </p>
    <p>
      {language === "English" ? "School Name" : "शाळेचे नाव"} : {schoolData.schoolName}
      <br /> <br /><br /><br /><span style={{marginLeft:'72px'}}> {language === "English" ? "Tal." : "ता."} {schoolData.taluka} , {language === "English" ? "Dist." : "जि."} {schoolData.jilha}</span>
    </p>
  </div>

  <div className='cenetrpartmasikpatr'>
    <p>{language === "English" ? `Class ${classMapping[selectedClass].English}` : `इ. ${classMapping[selectedClass].Marathi}`}</p>
    <p className='cenetrpartmasikpatr-p' style={{ display: 'inline-block', backgroundColor: 'black', color: 'white', padding: '10px', borderRadius: '5px', fontSize: '18px' }}>
      {language === "English" ? ` Monthly "B" Form` : `मासिक "ब" प्रपत्र`}
    </p>
  </div>

  <div className='rightpartmasikpatr'>
      <div className='rowmasikpatr'>
        <div className='columnmasikpatr'>
          <p>{language === "English" ? "Students count" : "पट"}: {countTotal}</p>
        </div>
        <div className='columnmasikpatr' style={{marginLeft:'8px', paddingRight:'0', marginRight:'0'}}>
          <p>{language === "English" ? "Working Days" : "कामाचे दिवस"}: {countCookedDays}</p>
        </div>
      </div>
      <hr style={{marginLeft:'-9px'}}/>
      <div className='rowmasikpatr' style={{paddingTop:'5px'}}>
      <p>{language === "English" ? "Month" : "माहे"}: <span style={{marginLeft:'10px'}}>{language === "English" ? selectedMonth : monthMapping[selectedMonth]} {selectedYear}</span></p>
      </div>
  </div>
</div>
                        </th>
                      </tr>
                    )}
            <tr>
            <th style={{ padding: ' 0', fontWeight: 'bold', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                {language === "English" ? "Sr. No." : " अ. क्र. "}
              </th>
              <th style={{ padding: '7px', fontWeight: 'bold', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                {language === "English" ? "Items" : "वस्तू"}
              </th>
              {modalData.slice(0, 17).map((row, index) => (
    <th key={index} style={{ padding: '5px 10px', fontWeight: 'bold', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
        {row.content}
    </th>
))}
            </tr>
          </thead>
          <tbody>
            <tr>
            <td style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
               1
              </td>
              <td style={{ padding: '4px', border: '1px solid black', textAlign: 'center', fontSize:'15px'}}>
                {language === "English" ? "Opening Balance (Previous Month Balance)" : "आरंभीची शिल्लक (मागील  महिन्याची शिल्लक) "}
              </td>
              {modalData.slice(0, 17).map((row) => (
                <td key={row.content} style={{ padding: '0px', border: '1px solid black',  textAlign: 'center', fontSize:'15px' }}>
                  {row.previousStock}
                </td>
              ))}
            </tr>
            <tr>
            <td style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
               2
              </td>
              <td style={{ padding: '4px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                {language === "English" ? " Received In Current Month" : "प्राप्त चालू महिन्यातील"}
              </td>
              {modalData.slice(0, 17).map((row) => (
                <td key={row.content} style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                  {row.receivedGoods}
                </td>
              ))}
            </tr>
            <tr>
            <td style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
               3
              </td>
              <td style={{ padding: '4px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                {language === "English" ? "Total Stock " : "एकूण साठा "} <br/>  ( 1 + 2)
              </td>
              {modalData.slice(0, 17).map((row) => (
                <td key={row.content} style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                  {row.totalGoods}
                </td>
              ))}
            </tr>
            <tr>
            <td style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
               4
              </td>
              <td style={{ padding: '4px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                {language === "English" ? "Cooked Food Days" : "अन्न शिजवलेले दिवस"}
              </td>
              {modalData.slice(0, 17).map((row) => (
                <td key={row.content} style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                  {row.cookedDays}
                </td>
              ))}
            </tr>
            <tr>
            <td style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
               5
              </td>
              <td style={{ padding: '4px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                {language === "English" ? "Beneficiary - current Month" : "लाभार्थी - चालू महिन्यातील"}
              </td>
              {modalData.slice(0, 17).map((row) => (
                <td key={row.content} style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                  {row.cookedDays * countlabharthi}
                </td>
              ))}
            </tr>
            <tr>
            <td style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
               6
              </td>
              <td style={{ padding: '4px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                {language === "English" ? "Cooked rice and grains" : "शिजवलेला तांदूळ व धान्यादी माल"}
              </td>
              {modalData.slice(0, 17).map((row) => (
                <td key={row.content} style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                  {row.itemsUsed}
                </td>
              ))}
            </tr>
            <tr>
            <td style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
               7
              </td>
              <td style={{ padding: '4px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                {language === "English" ? "Month End Balance" : " महिना अखेरची शिल्लक"} <br/> (3 - 6)
              </td>
              {modalData.slice(0, 17).map((row) => (
                <td key={row.content} style={{ padding: '0px', border: '1px solid black', textAlign: 'center', fontSize:'15px' }}>
                  {row.remainingStock}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
        <div style={{ display: 'flex', width: '100%' }}>
  {/* First Div: Table */}
  <div style={{ width: '30%', padding: '7px' }}>
    <table style={{ width: '100%' , fontSize:'13px'}}>
      <thead>
        <tr>
          <th style={{ padding: '5px', border: '1px solid black', textAlign: 'center' }}>
            {language === "English" ? 'Details' : 'तपशील'}
          </th>
          <th colSpan={2} style={{ padding: '5px', border: '1px solid black', textAlign: 'center' }}>
            {language === "English" ? 'Consumption kg/litre' : 'वापर किलो/लिटर '}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td  style={{ padding: '7px'}}>{language === "English" ? 'vegetables' : 'भाजीपाला'}</td>
          <td style={{ padding: '7px'}}>{(data[17].useVastu)/1000}</td>
          <td style={{ padding: '7px'}}>{language === "English" ? 'k.g.' : 'कि.ग्रा.'}</td>
        </tr>
        <tr>
          <td style={{ padding: '7px'}}>{language === "English" ? 'milk / milk powder' : 'दूध/ दूध पावडर'}</td>
          <td style={{ padding: '7px'}}>{(data[18].useVastu/1000)}</td>
          <td style={{ padding: '7px'}}>{language === "English" ? 'liter' : 'लिटर'}</td>
        </tr>
        <tr>
          <td style={{ padding: '7px'}}>{language === "English" ? 'sugar / jaggery' : 'साखर / गूळ'}</td>
          <td style={{ padding: '7px'}}>{(data[19].useVastu)/1000}</td>
          <td style={{ padding: '7px'}}>{language === "English" ? 'k.g.' : 'कि.ग्रा.'}</td>
        </tr>
        <tr>
          <td style={{ padding: '7px'}}>{language === "English" ? 'Soybean wadi' : 'सोयाबीन वडी'}</td>
          <td style={{ padding: '7px'}}>{(data[20].useVastu)/1000}</td>
          <td style={{ padding: '7px'}}>{language === "English" ? 'k.g.' : 'कि.ग्रा.'}</td>
        </tr>
        <tr>
          <td style={{ padding: '7px'}}>{language === "English" ? 'ragi satva' : 'नाचणी सत्व'}</td>
          <td style={{ padding: '7px'}}>{(data[21].useVastu/1000)}</td>
          <td style={{ padding: '7px'}}>{language === "English" ? 'k.g.' : 'कि.ग्रा.'}</td>
        </tr>
      </tbody>
    </table>
  </div>

  
  <div style={{ width: '20%', padding: '10px', marginLeft: '20px' , fontSize:'14px'}}>
    <div style={{ border: '1px solid gray', padding: '5px', marginBottom: '10px', display:'flex' }}>
      <div style={{ width: '78%'}}>{language === "English" ? "No. of cooks and helpers" : "स्वयंपाकी तथा मदतनीस संख्या"} - </div>
      <input style={{ width: '20%', border:'none'}}
        type="number"
        value={numberOfCooks}
        onChange={(e) => setNumberOfCooks(e.target.value)} 
      />
    </div>
    <div style={{ border: '1px solid gray', padding: '5px' }}>
      {language === "English" ? "Beneficiary Count" : "लाभार्थी संख्या"} - {countlabharthi}
    </div>
  </div>

 
  <div style={{ width: '45%', padding: '10px', fontSize:'14px',marginLeft:'30px', right:'0px',textAlign: 'right' }}>
    <div>
      <p>{language==="English"?"The monthly B sheet of this has been checked and the stock register is correct and accurate.":"सदरचे मासिक ब पत्रक तपासले असुन साठा नोंदवही प्रमाणे बरोबर व अचुक आहे."}</p>
      <p>{language==="English"?"The monthly B sheet should be submitted to the Head of the Centre by the 1st of the month.":"सदरचे मासिक ब पत्रक महिन्यातील 1 तारखेपर्यंत  केंद्रप्रमुख यांच्या कडे जमा करावे."}</p>
    

    </div>
    <div style={{ textAlign: 'right', marginTop: '70px' }}>
      {language === "English" ? "Principal Signature and Stamp" : "मुख्याध्यापक सही व शिक्का"} 
    </div>
  </div>
</div>
      </div>
      <div style={{ textAlign: 'right', marginTop: '20px' }}>
        <button onClick={handlePrint} style={{
          padding: '12px 25px',
          backgroundColor: '#007BFF',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
          transition: 'background-color 0.2s ease',
          marginRight: '10px',
        }}>
          {language === "English" ? "Print" : "प्रिंट करा"}
        </button>

        <button onClick={closeModal} style={{
          padding: '12px 25px',
          backgroundColor: '#FF4136',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
          transition: 'background-color 0.2s ease',
        }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#E04A3F'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#FF4136'}
        >
          {language === "English" ? "Close" : " बंद करा"}
        </button>
      </div>
    </div>
  </div>
)}
      </div>
      <Footer />
      <style jsx>
        {`
          
.container-masikpatra {
  display: flex;
  justify-content: space-between;
  align-items: flex-start; 
  padding: 10px 0px; 
  padding-bottom: 20px; 
}

.leftpartmasikpatr, .cenetrpartmasikpatr, .rightpartmasikpatr {
 margin: 0 10px;
}
.leftpartmasikpatr {
 text-align:left;
}

.rightpartmasikpatr {
width:230px;
  border: 1px solid #000; /* Add border to the right part */
  padding: 10px; /* Add padding inside the border */
}

.rowmasikpatr {
  display: flex; 
  margin:-8px !important;
  padding:0;
}

.columnmasikpatr {
  margin-top:10px;
  margin-bottom:-8px;
  flex: 1;
  text-align: left; /* Align text to the left */
}
          td{
          padding:0;}
          ` }
      </style>
    </div>
  );
}

export default Sadhyachasatha;

const loadingoverlay = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1,
}